import clsx from "clsx"
import React, { useEffect, useState } from "react"
import { DadosDestinoTransferencia } from "../../types/DadosDestinoTransferencia"

const estilosFormulario = require('../../estilos/formulario.module.scss').default
const estilosBotoes = require('../../estilos/botoes.module.scss').default
const estilosInputs = require('../../estilos/inputs.module.scss').default

export type DestinoTransferenciaProps = {
    dados: DadosDestinoTransferencia
    somenteLeitura: boolean
    processando: boolean
    onAplicar: (codigoFilialDestino: string) => void
}

export const DestinoTransferencia = (props: DestinoTransferenciaProps) => {
    const [codigoSelecionado, setCodigoSelecionado] = useState<string>(props.dados?.FilialDestinoCodigo ?? "")

    useEffect(() => {
        setCodigoSelecionado(props.dados?.FilialDestinoCodigo ?? "")
    }, [props.dados?.FilialDestinoCodigo])

    const itensDestino = (props.dados?.Destinos ?? []).map(filial => ({ chave: filial.Codigo, valor: filial.Descricao }))
    const filialDestino = props.dados?.FilialDestino

    return <>
        <div id="DestinoTransferencia_ContainerPrincipal" className={clsx(estilosFormulario.formulario)} style={{ marginTop: "16px" }}>
            <label className="obrigatorio" id="DestinoTransferencia_LabelFilialDestino">Filial de Destino</label>
            <select
                id="DestinoTransferencia_SelecaoFilialDestino"
                className={clsx(estilosInputs.inputPadrao)}
                disabled={props.somenteLeitura}
                value={(codigoSelecionado) ?? ""}
                onChange={e => setCodigoSelecionado(e.target.value)}
            >
                <option value="">Selecione</option>
                {itensDestino.map(item => (
                    <option key={item.chave} value={item.chave}>{item.valor}</option>
                ))}
            </select>
        </div>

        {!props.somenteLeitura &&
            <div id="DestinoTransferencia_BotaoAplicarContainer">
                <button
                    className={clsx(estilosBotoes.botaoPrimario, "no-global-button")}
                    style={{ marginTop: "10px" }}
                    disabled={props.processando || codigoSelecionado.length == 0}
                    id="DestinoTransferencia_BotaoAplicar"
                    onClick={() => props.onAplicar(codigoSelecionado)}
                >
                    Aplicar
                </button>
            </div>
        }

        {props.dados?.FilialDestinoCodigo?.length > 0 && filialDestino != null &&
            <div id="DestinoTransferencia_DadosContainer" className="responsiv">
                <h3 id="DestinoTransferencia_H3DadosBasicos">Dados Básicos</h3>
                <table className="t3" id="DestinoTransferencia_Tabela">
                    <tbody>
                        <tr id="FilialDestino_RazaoSocial">
                            <th>Razão Social</th>
                            <td>{filialDestino.RazaoSocial}</td>
                        </tr>
                        <tr id="FilialDestino_CNPJ">
                            <th>CNPJ</th>
                            <td id="DestinoTransferencia_Cnpj">{filialDestino.CpfCnpj}</td>
                        </tr>
                        {filialDestino.InscricaoEstadual?.length > 0 &&
                            <tr id="FilialDestino_InscricaoEstadual">
                                <th>Inscrição Estadual</th>
                                <td>{filialDestino.InscricaoEstadual}</td>
                            </tr>
                        }
                        {filialDestino.InscricaoSuframa?.length > 0 &&
                            <tr id="FilialDestino_InscricaoSuframa">
                                <th>Inscrição Suframa</th>
                                <td>{filialDestino.InscricaoSuframa}</td>
                            </tr>
                        }
                        <tr id="FilialDestino_Contribuinte">
                            <th>Contribuinte</th>
                            <td><input disabled id="destinoTransferencia_Contribuinte" type="checkbox" checked={!!filialDestino.Contribuinte} readOnly /></td>
                        </tr>
                        {filialDestino.Email?.length > 0 &&
                            <tr id="FilialDestino_emailNfe">
                                <th>E-mail NF-e</th>
                                <td>{filialDestino.Email}</td>
                            </tr>
                        }
                        {filialDestino.Telefone?.length > 0 &&
                            <tr id="FilialDestino_Telefone">
                                <th>Telefone</th>
                                <td>{filialDestino.Telefone}</td>
                            </tr>
                        }
                    </tbody>
                </table>

                <h3 id="DestinoTransferencia_H3Endereco">Endereço</h3>
                <table className="t3" id="DestinoTransferencia_TabelaEndereco">
                    <tbody>
                        <tr id="FilialDestino_End_Logradouro">
                            <th>Logradouro</th>
                            <td>{filialDestino.Endereco}</td>
                        </tr>
                        <tr id="FilialDestino_End_Numero">
                            <th>Número</th>
                            <td>{filialDestino.NumeroEndereco}</td>
                        </tr>
                        <tr id="FilialDestino_End_Complemento">
                            <th>Complemento</th>
                            <td>{filialDestino.ComplementoEndereco}</td>
                        </tr>
                        <tr id="FilialDestino_End_Bairro">
                            <th>Bairro</th>
                            <td>{filialDestino.Bairro}</td>
                        </tr>
                        <tr id="FilialDestino_End_Cidade">
                            <th>Cidade</th>
                            <td>{filialDestino.Cidade?.Nome}</td>
                        </tr>
                        <tr id="FilialDestino_End_UF">
                            <th>UF</th>
                            <td>{filialDestino.SiglaUf}</td>
                        </tr>
                        <tr id="FilialDestino_End_CEP">
                            <th>CEP</th>
                            <td id="FilialDestino_End_CEP_valor">{filialDestino.Cep}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        }
    </>
}
